import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          © {new Date().getFullYear()} <span className="gradient-text">Avinash Bandi</span> ·
          Built with React &amp; ❤️
        </p>
      </div>
    </footer>
  );
}
